import { IconTab } from "@/src/components/iconTab";
import { Hospitalisation, Patient, Discharge } from "@/src/data/allTypes";
import { getItemId, getUserId, jsonAbstract } from "@/src/utils/utils";
import { RiUser2Line } from "react-icons/ri";
import { getStandardConfidentiality } from "../../patients/confidentialitiesHook";
import {
  closeDrawer,
  openConfirmDialog,
  openDrawer,
} from "@/src/components/dialogs";
import { DischargeForm } from "../dischargeForm";
import apiFetch from "@/src/utils/apiFetch";
import { BiExit } from "react-icons/bi";

export default function DischargeButton({
  patient,
  parent,
  onSave,
}: {
  patient: Patient;
  parent: Hospitalisation;
  onSave: (item: Discharge) => void;
}) {
  return (
    <IconTab
      id={"discharge"}
      activeTabId={null}
      isHorizontal={true}
      name={"Sortie définitive"}
      icon={<BiExit size={20} />}
      onChange={async () => {
        let discharge: Discharge = {
          type: "discharge",
          dischargeType: "immediate",
          exitMode: "authorized",
          status: "pending",
          notes: "",
          creator: getUserId(),
          exitDate: null,
          patient,
          parent: jsonAbstract(parent.id),
          confidentiality: getStandardConfidentiality(patient),
          readBy: [getUserId()],
        };

        await openDischargeDrawer({
          patient,
          parent,
          discharge,
          onSave: (discharge) => {
            if (discharge.dischargeType == "immediate")
              closeDrawer("hospitalisationDrawer");
            onSave(discharge);
          },
        });
      }}
    />
  );
}

export async function openDischargeDrawer({
  parent,
  patient,
  discharge,
  onSave,
}: {
  parent: Hospitalisation;
  patient: Patient;
  discharge: Discharge;
  onSave: (discharge: Discharge) => void;
}) {
  await openDrawer({
    id: "dischargeDrawer",
    title: "Sortie définitive",
    content: (
      <DischargeForm
        patient={patient}
        parent={parent}
        discharge={discharge}
        onChange={(newValue) => {
          discharge = newValue;
        }}
      ></DischargeForm>
    ),
    onConfirm: async () => {
      if (discharge.dischargeType == "immediate") {
        let isConfirmed = false;
        await openConfirmDialog({
          title: "Sortie définitive",
          content: <div>Voulez-vous vraiment faire sortir le patient ?</div>,
          onConfirm: async () => {
            isConfirmed = true;
          },
        });
        if (!isConfirmed) return;
        discharge.status = "finished";
      }

      discharge = await apiFetch("discharges", "addOne", {
        discharge,
      });
      if (!discharge) return;
      await apiFetch(
        "hospitalisations",
        "addOne",
        {
          hospitalisation: {
            id: parent?.id,
            type: "hospitalisation",
            discharge,
            status:
              discharge.dischargeType == "immediate" ? "finished" : undefined,
          },
        },
        "Erreur lors de l'enregistrement de l'hospitalisation"
      );

      if (discharge.dischargeType == "immediate")
        closeDrawer("hospitalisationDrawer");

      onSave(discharge);
    },
  });
}
